import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: 'app-capacity-warnings-dialog',
  templateUrl: './capacity-warnings-dialog.component.html',
  styleUrls: ['./capacity-warnings-dialog.component.scss']
})
export class CapacityWarningsDialogComponent implements OnInit {

  //#region Fields
  public message: string;
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef
  ) {
    if (this.config.data != undefined && this.config.data.message) {
      this.message = this.config.data.message;
    }
  }

  ngOnInit(): void {
  }

  //#endregion

  //#region Public Methods
  public createNew(): void {
    this.ref.close(true);
  }

  public cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
